import SearchCard from "components/Cards/SearchCard";
import React from "react";
import { useHistory } from "react-router";

const SearchesCardsPage = (props): JSX.Element => {
    const { results } = props;

    const history = useHistory();

    const handleSearchCardClick = (searchId: string): void => {
        history.push(`/results/${searchId}`);
    };

    return <>{results?.length > 0 && results.map((resultItem) => <SearchCard key={resultItem.id} resultItem={resultItem} onClick={() => handleSearchCardClick(resultItem.id)} />)}</>;
};

export default SearchesCardsPage;
